import { useState } from "react";
import styled from "styled-components";
import { toast } from "react-toastify";
import { Button, ModalDefault, Notice, Text } from "@ficatranquilo/contabilidade.com-ui";
import useService from "@hooks/useService";
import { escapeHtml } from "@components/ow";

const Body = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

/** Tirar uma pessoa do grupo. O modal fica aberto se o back recusar. */
export default function RemoveMemberModal({ groupId, member, onClose, onRemoved }) {
  const groupsService = useService("confidentialGroups");
  const [loading, setLoading] = useState(false);

  function close() {
    if (!loading) onClose();
  }

  async function confirm() {
    setLoading(true);
    try {
      await groupsService.removeMember(groupId, member.user.id);
      toast.success("Pessoa retirada do grupo.");
      setLoading(false);
      onRemoved(member.user.id);
    } catch (err) {
      console.error(err);
      toast.error(err?.response?.data?.msg || "Erro ao tirar a pessoa do grupo.");
      setLoading(false);
    }
  }

  return (
    <ModalDefault
      $showModal
      $setShowModal={close}
      $noClose={loading}
      $size="medium"
      $title="Tirar do grupo?"
      $contentBackground="N0"
      $footer={
        <>
          <Button $text="Cancelar" $variant="outline" $action={close} $isDisabled={loading} $noWidth />
          <Button $text="Tirar do grupo" $variant="danger" $action={confirm} $isLoading={loading} $noWidth />
        </>
      }
    >
      <Body>
        <Text
          $text="<strong>%s</strong>"
          $replaces={[escapeHtml(member.user.name || "-")]}
          $variant="paragraph_small_medium"
          $color="N900"
          $colorEmphasis="N900"
        />
        <Notice
          $variant="orange"
          $text="Os contratos, cronogramas, valores, notas fiscais, o ponto e as horas dessa pessoa passam a aparecer para quem tem essas permissões de leitura (as de horas, nos projetos de cada um), a menos que ela esteja em outro grupo confidencial."
        />
      </Body>
    </ModalDefault>
  );
}
